import Vue from 'vue';
import storage from '@js/storage';

export const state = () => ({
    data: {
    },
    showLoginFlag: false,
    showCallBack: null
});

export const mutations = {
    updateData(state, n) {
        state.data = n;
        storage.setSession({
            userinfo: n,
        });
    },
    upateLoginState(state, n) {
        if(n.show){
            state.data = {};
            storage.setSession({
                userinfo: {},
            });
        }
        state.showLoginFlag = n.show
        state.showCallBack = n.callback == null ? null : n.callback
    },
    upateLoginOutState(state, n) {
        state.data = {};
        storage.setSession({
                userinfo: {},
        });
        state.showLoginFlag = n.show
        state.showCallBack = n.callback == null ? null : n.callback
    },
};

export const getters = {
    getData(state) {
        var data = {};
        if (process.browser) {
            let stateData = state.data || {},
                keys = Object.keys(stateData);
            if (keys.length) {
                data = state.data;
            } else {
                data = storage.getSession('userinfo')
            }
        }
        return data;
    },
    // 用户昵称
    getNickname(state, getters) {
        // console.log("state",getters.getData.nickname)
        return getters.getData.nickname;
    },
    //用户头像
    getHeadportraitpath(state, getters) {
        return getters.getData.headportraitpath;
    },
};

export const actions = {
    /**
     * 请求用户身份信息，仅在有SERIAL_CODE时请求
     * @param {Object} state state实例
     * @param {Object} obj 参数
     * @returns
     */
    queryUserInfo(state, obj = { requery: false }) {
        const SERIAL_CODE = this.$cookies.get('SERIAL_CODE');

        if (!SERIAL_CODE) return;
        // userlogin/userinfo
        var query = () => {
            Vue.prototype.$get(`${this.state.api.webUrl}/setup/getuserinfo.json`, data => {
                state.commit('updateData', data);
                state.commit("upateLoginState", { show: false, callback: null })
            });
        };

        if (obj.requery) {
            query();
        } else {
            if (state.getters.getNickname) return;

            query();
        }
    },
    /**
     * 验证码登录
     * @param {Object}} state state实例
     * @param {Object} obj 传入的参数，包含data，success
     */
    smsloginHandler(state, { data, success, complete, error }) {
        Vue.prototype.$ajax({
            type: 'post',
            url: `${this.state.api.webUrl}/userlogin/smslogin.json`,
            data,
            callback: datas => {
                state.commit('updateData', datas);
                success.call(this, datas);
                storage.setSession('isFirstLogin', datas.isfirstlogin)
            },
            complete() {
                complete && complete.call(this)
            },
            error() {
                error && error.call(this);
            }
        });
    },
    /**
     * 账号密码登录
     * @param {Object}} state state实例
     * @param {Object} obj 传入的参数，包含data，success
     */
    accountLoginHandler(state, { data, success, complete, error }) {
        Vue.prototype.$ajax({
            type: 'post',
            url: `${this.state.api.webUrl}/userlogin/usernameAndPwdLogin.json`,
            data,
            callback: datas => {
                state.commit('updateData', datas);
                success.call(this, datas);
                storage.setSession('isFirstLogin', datas.isfirstlogin)
            },
            complete() {
                complete && complete.call(this)
            },
            error() {
                error && error.call(this);
            }
        });
    },
    /**
     * 账号密码注册
     * @param {Object}} state state实例
     * @param {Object} obj 传入的参数，包含data，success
     */
    accountRegisterHandler(state, { data, success, complete, error }) {
        Vue.prototype.$ajax({
            type: 'post',
            url: `${this.state.api.webUrl}/userlogin/regist.json`,
            data,
            callback: datas => {
                state.commit('updateData', datas);
                success.call(this, datas);
                storage.setSession('isFirstLogin', datas.isfirstlogin)
            },
            complete() {
                complete && complete.call(this)
            },
            error() {
                error && error.call(this);
            }
        });
    },
    /**
     * 退出登录，成功后清空用户信息缓存
     * @param {Object} state state实例
     * @returns
     */
    logoutHandler(state) {
        const SERIAL_CODE = this.$cookies.get('SERIAL_CODE');

        if (!SERIAL_CODE) return;

        Vue.prototype.$post(`${this.state.api.webUrl}/userlogin/logout.json`, data => {
            localStorage.clear();
            state.commit('updateData', {});
            state.commit("upateLoginState", { show: false, callback: null })
            if (/^(\/user)/.test(window.location.pathname)) {
                window.location.replace('/');

                return;
            }

            window.location.reload();
        });
    },
    nuxtServerInit({ commit }, { req }) {
        // console.log(req.headers.cookie);
    },
};
